import React from 'react';
import { connect } from 'react-redux';
import { Route, Switch, Redirect } from 'react-router-dom';
import AddCompetitorsModal from 'components/Modals/AddCompetitorsModal/AddCompetitorsModal.jsx';
import AddSubscriptionsModal from 'components/Modals/AddSubscriptionsModal/AddSubscriptionsModal.jsx';
import { Page } from '@bit/knotchinc.web-react-components.page';
import Text from '@bit/knotchinc.web-react-components.text';
import PageHeader from 'components/Global/PageHeader/PageHeader.jsx';
import CompetitorsFeedView from './CompetitorsFeedView.jsx';
import SavedFeedView from './SavedFeedView.jsx';
import SubscribedFeedView from './SubscribedFeedView.jsx';

export class LibraryView extends React.Component {
  constructor() {
    super();
    this.state = {
      competitorsModalOpen: false,
      subscriptionsModalOpen: false,
    };
  }

  render() {
    const { match, location, userEntity } = this.props;
    const { competitorsModalOpen, subscriptionsModalOpen } = this.state;
    const closeCompetitorsModal = () => this.setState({ competitorsModalOpen: false });
    const closeSubscriptionsModal = () => this.setState({ subscriptionsModalOpen: false });

    const tabs = [
      { text: 'Subscribed', title: 'Subscribed', link: `/blueprint/library/subscribed` },
      { text: 'Saved', title: 'Saved', link: `/blueprint/library/saved` },
    ];

    let actions = [];

    if (location.pathname.indexOf('subscribed') > -1) {
      actions = [{
        text: 'Add Subscription',
        action: () => this.setState({ subscriptionsModalOpen: true }),
        selected: false,
      }];
    } else if (location.pathname.indexOf('competitors') > -1) {
      actions = [{
        text: 'Add Competitors',
        action: () => this.setState({ competitorsModalOpen: true }),
        selected: false,
      }];
    }

    if (userEntity) {
      tabs.unshift({
        text: 'Competitors',
        title: 'Competitors',
        link: `/blueprint/library/competitors`,
      });
    }

    const [currentRoute] = tabs.filter(tab => tab.link === window.location.pathname);
    const titleText = currentRoute ? currentRoute.title : '';
    const title = (<span>{titleText} <Text color="palette.7" display="inline-block">Library</Text></span>);

    return (
      <Page>
        <PageHeader title={title} fetched tabs={tabs} actionButtons={actions} />
        <Switch>
          <Redirect exact from={match.path} to={`${match.path}/${userEntity ? `competitors` : `subscribed`}`} />
          {userEntity && <Route path={`${match.path}/competitors`} component={CompetitorsFeedView} />}
          <Route path={`${match.path}/saved`} component={SavedFeedView} />
          <Route path={`${match.path}/subscribed`} component={SubscribedFeedView} />
        </Switch>
        <AddCompetitorsModal
          isOpen={competitorsModalOpen}
          close={closeCompetitorsModal}
        />
        <AddSubscriptionsModal
          isOpen={subscriptionsModalOpen}
          close={closeSubscriptionsModal}
        />
      </Page>
    );
  }
}

const mapStateToProps = ({ Account: { userEntity } }) => ({ userEntity });

export default connect(mapStateToProps)(LibraryView);
